/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorTextPrimary = "#161616";
export const ColorTextSecondary = "#161616";
export const ColorBackgroundPrimary = "#FFD3A8";
export const ColorIconPrimary = "#161616";
export const ColorIconSecondary = "#161616";
